import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { urlEndPoints } from '../config/end-points';
import { Wish } from '../models/wish.model';

@Injectable({
  providedIn: 'root',
})
export class WishDal {
  constructor(private httpClient: HttpClient) {}

  getWishesByProfileAndType(profileId: string, type: string, isIndividualJobDescription: boolean): Observable<any[]> {
    return this.httpClient.get<any[]>(
      urlEndPoints.wishes +
        `wishTime/${profileId}?type=${type}&isIndividualJobDescription=${isIndividualJobDescription}`
    );
  }

  getWishesByProfileAndType2(profileId: string, isIndividualJobDescription: boolean): Observable<Wish[]> {
    return this.httpClient.get<Wish[]>(
      urlEndPoints.wishes + `${profileId}?isIndividualJobDescription=${isIndividualJobDescription}`
    );
  }

  getWishesByProfileAndTypeFromHospital(profileId: string, type: string, hospitalId: string): Observable<any[]> {
    return this.httpClient.get<any[]>(
      urlEndPoints.wishes + `wishTime/${profileId}?type=${type}&hospital=${hospitalId}`
    );
  }

  editWishes(profileId: string, wishes: any) {
    return this.httpClient.post<any>(urlEndPoints.wishes + 'editWishes/' + profileId, wishes);
  }

  deleteMany(ids: string[]) {
    return this.httpClient.post<any>(urlEndPoints.wishes + 'deleteMany', { ids });
  }

  addMany(wishes: Wish[]) {
    return this.httpClient.post<any>(urlEndPoints.wishes + 'addMany', wishes);
  }

  updateMany(wishes: Wish[]) {
    return this.httpClient.post<any>(urlEndPoints.wishes + 'updateMany', wishes);
  }
}
